import {getHours} from 'date-fns';
type TranslationFunction = (key: string, defaultValue: string) => string;

export const renderedGreeting = (tt: TranslationFunction): string => {
  const nowHours = getHours(new Date());
  let greeting;

  if (nowHours >= 0 && nowHours <= 11) {
    greeting = tt('header.greeting.morning', 'Good morning, ');
  } else if (nowHours >= 12 && nowHours <= 16) {
    greeting = tt('header.greeting.afternoon', 'Good afternoon, ');
  } else {
    greeting = tt('header.greeting.evening', 'Good evening, ');
  }

  return greeting;
};
